import { render, staticRenderFns } from "./AuctionBidEdit.vue?vue&type=template&id=010b9b8e"
import script from "./AuctionBidEdit.vue?vue&type=script&lang=js"
export * from "./AuctionBidEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports